import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/** Merges Tailwind class names, resolving conflicts (via tailwind-merge) after combining with clsx. */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}
